// extracted by mini-css-extract-plugin
export default {"flowsheetFooterContainer":"FlowsheetFooter_flowsheetFooterContainer__Xn3qY","flexEnd":"FlowsheetFooter_flexEnd__-h3Xm"};